import { useEffect } from "react";

// Lightweight client-side SEO: sets document.title + meta/OG tags, restores on unmount.
export const useSeo = ({ title, description, image } = {}) => {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    const setMeta = (attr, key, val) => {
      if (!val) return null;
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      let created = false;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
        created = true;
      }
      const prev = el.getAttribute("content");
      el.setAttribute("content", val);
      return { el, prev, created };
    };

    const tags = [
      setMeta("name", "description", description),
      setMeta("property", "og:title", title),
      setMeta("property", "og:description", description),
      setMeta("property", "og:type", "website"),
      setMeta("name", "twitter:card", "summary_large_image"),
      setMeta("name", "twitter:title", title),
      setMeta("name", "twitter:description", description),
      image ? setMeta("property", "og:image", image) : null,
      image ? setMeta("name", "twitter:image", image) : null,
    ].filter(Boolean);

    return () => {
      document.title = prevTitle;
      tags.forEach(({ el, prev, created }) => {
        if (created) el.remove();
        else if (prev !== null) el.setAttribute("content", prev);
      });
    };
  }, [title, description, image]);
};
